<div class="base-list">
  <p-table
    [value]="data"
    [lazy]="true"
    [paginator]="paginator"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [first]="first"
    [sortField]="defaultSortField"
    [sortOrder]="defaultSortOrder"
    [showGridlines]="showGridlines"
    [stripedRows]="stripedRows"
    [rowHover]="rowHover"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} / {totalRecords}"
    (onLazyLoad)="onLazyLoad($event)"
    [tableStyle]="{ 'min-width': '100%' }"
    [expandedRowKeys]="expandedRowKeys"
    [dataKey]="dataKey"
    (onRowExpand)="onRowExpandEvent($event)"
    styleClass="base-list__table">

    <ng-template #header>
      <tr>
        <th *ngIf="isExpandable" style="width: 3rem"></th>
        <th
          *ngFor="let col of columns; trackBy: trackByColumn"
          [pSortableColumn]="col.sortable ? (col.sorterField || col.field) : undefined"
          [style.width]="col.width || 'auto'">
          {{ col.header }}
          <p-sortIcon *ngIf="col.sortable" [field]="col.sorterField || col.field" />
        </th>
      </tr>
    </ng-template>

    <ng-template #body let-row let-expanded="expanded">
      <tr class="base-list__row" [ngClass]="getRowClass(row)" (click)="onRowClick(row)">
        <td *ngIf="isExpandable" style="width: 3rem">
          <button
            type="button"
            class="p-link"
            [pRowToggler]="row"
            [attr.aria-expanded]="expanded">
            <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
          </button>
        </td>
        <td *ngFor="let col of columns; trackBy: trackByColumn">
          <ng-container *ngIf="col.bodyTemplate; else defaultCell">
            <ng-container
              *ngTemplateOutlet="col.bodyTemplate; context: { $implicit: row, column: col }">
            </ng-container>
          </ng-container>
          <ng-template #defaultCell>
            <ng-container [ngSwitch]="col.type">
              <span *ngSwitchCase="'date'">
                {{ getCellValue(row, col) | displayDateTime }}
              </span>
              <span *ngSwitchCase="'number'">
                {{ getCellValue(row, col) | number }}
              </span>
              <span *ngSwitchCase="'boolean'">
                <i
                  class="fas"
                  [ngClass]="getCellValue(row, col) ? 'fa-check text-success' : 'fa-times text-danger'">
                </i>
              </span>
              <span *ngSwitchDefault>{{ getCellValue(row, col) }}</span>
            </ng-container>
          </ng-template>
        </td>
      </tr>
    </ng-template>

    <ng-template #expandedrow let-row>
      <tr *ngIf="rowExpandTemplate">
        <td [attr.colspan]="columns.length + 1" class="p-0">
          <ng-container *ngTemplateOutlet="rowExpandTemplate; context: { $implicit: row }">
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template #paginatorleft>
      @if (config?.totalLabelFn) {
        <span class="base-list__total-label small text-muted">{{ config.totalLabelFn!(totalRecords) }}</span>
      }
    </ng-template>

    <ng-template #paginatorright>
      <button
        type="button"
        class="base-list__refresh-btn d-inline-flex align-items-center justify-content-center flex-shrink-0 p-0 border-0 bg-transparent"
        [pTooltip]="refreshLabel"
        tooltipPosition="top"
        (click)="refresh()">
        <i class="pi pi-refresh"></i>
      </button>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td [attr.colspan]="isExpandable ? columns.length + 1 : columns.length" class="base-list__empty">
          <div class="base-list__empty-content d-flex flex-column align-items-center gap-2 text-muted">
            <i class="fas fa-inbox"></i>
            <span class="small">{{ emptyMessage }}</span>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template #loadingbody>
      <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
        <td *ngIf="isExpandable"></td>
        <td *ngFor="let col of columns; trackBy: trackByColumn">
          <div class="base-list__skeleton"></div>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
